import { createContext, useEffect, useState, type ReactNode } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { auth } from './firebase';

// undefined = ещё грузим, null = не залогинен, User = залогинен.
export type AuthState = User | null | undefined;

export const AuthContext = createContext<AuthState>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthState>(undefined);

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => setUser(u));
  }, []);

  return <AuthContext.Provider value={user}>{children}</AuthContext.Provider>;
}
